export default class DropdownItemConfig {
  title:string
  icon:string
  divided:boolean
  handleClick = ()=>{alert("未实现")}
}